export const AUTH_BACKEND_UPSTREAM_COOKIE = 'auth_backend_upstream_migration'

export const AUTH_BACKEND_UPSTREAM_COOKIE_TTL_SECONDS = 3600

export const AUTH_BACKEND_UPSTREAM_VARIANTS = {
  CONTROL: 'control',
  AUTH_SERVER: 'auth-server',
  NOT_PARTICIPATING: 'not-participating',
} as const

export type AuthBackendUpstreamVariant =
  (typeof AUTH_BACKEND_UPSTREAM_VARIANTS)[keyof typeof AUTH_BACKEND_UPSTREAM_VARIANTS]

export const AUTH_BACKEND_UPSTREAM_ARGOS = {
  experimentGroup: 'signup',
  experimentName: 'auth_backend_upstream_migration',
  controlKey: AUTH_BACKEND_UPSTREAM_VARIANTS.CONTROL,
} as const

export const SIGNIN_UPSTREAM_VALUES = {
  BIFROST: 'bifrost',
  AUTH_SERVER: 'auth-server',
} as const

export type SigninUpstream = (typeof SIGNIN_UPSTREAM_VALUES)[keyof typeof SIGNIN_UPSTREAM_VALUES]
